export function buildUserFields(userInfo: any): any {
	return {
		userIdType: userInfo.userIdType,
	};
}
